"use client";

// Fehlerzustand: ein Satz, ein Knopf. Die technische Meldung bleibt
// auf dem Server (Next ersetzt sie im Produktionsbau ohnehin).
import { useEffect } from "react";
import { TriangleAlert } from "lucide-react";
import { Button, EmptyState } from "@/components/ui";

export default function GruppenFehler({ error, retry }: { error: Error & { digest?: string }; retry: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <EmptyState
      icon={TriangleAlert}
      title="Die Gruppen ließen sich nicht laden"
      description={error.digest ? `Fehlerkennung ${error.digest} — bitte melden, wenn es bleibt.` : "Bitte noch einmal versuchen."}
      action={<Button onClick={() => retry()}>Noch einmal</Button>}
    />
  );
}
